<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("products") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div
            class="text-right pb-3 ma-n2 d-flex align-center flex-wrap justify-md-space-between"
          >
            <div class="pa-2">
              <back-btn />
            </div>
            <!--            <div class="" v-if="canMoveProduct">-->
            <!--              <v-btn-->
            <!--                @click="openMoveProductDialog"-->
            <!--                :disabled="selectedItems.length === 0"-->
            <!--                color="primary"-->
            <!--              >-->
            <!--                {{ $t("moveProduct") }}-->
            <!--              </v-btn>-->
            <!--            </div>-->
          </div>

          <table-with-filter
            fixed-header
            @update:sort="getProductItemsBySort"
            :options.sync="configuration.options"
            hide-default-footer
            :headers="headers"
            :items="items"
            class="table-wth-children table_cover"
          >
            <template #item.number="{ item }">
              <span>{{ item.number }}</span>
              <v-checkbox
                v-if="
                  canChangeMaterial &&
                  !trueSet(item.toWarehouseApplicationInprogress)
                "
                multiple
                :value="item.id"
                v-model="selectedItems"
                hide-details
                dense
                class="mt-0 pt-0 ml-4"
              ></v-checkbox>
            </template>
            <template #item.productName="{ item }">
              {{ item[`name_${$i18n.locale}`] }}
            </template>
            <template
              #item.contractCode="{
                /**
                 * @type Object
                 * @property {string} contractFileName
                 */
                item,
              }"
            >
              <Downloader
                v-if="item['productResourceLink']"
                :address="item['productResourceLink']"
                :file-name="item.productResourceName"
              >
                <template #default="{ downloadFile }">
                  <a
                    class="text-decoration-underline"
                    @click.prevent="downloadFile"
                    >{{ item.contractCode }}</a
                  >
                </template>
              </Downloader>
            </template>
            <template #filter.contractCode>
              <div class="pa-1">
                <custom-input-text
                  v-model="ourProductFilter.contractNumb"
                  @input="onChangeHandler"
                  clearable
                  class="user_input no-margin"
                  name="select_on_block"
                />
              </div>
            </template>
            <template #filter.accountingCode>
              <div class="pa-1">
                <custom-input-text
                  v-model="ourProductFilter.accountingCode"
                  @input="onChangeHandler"
                  clearable
                  class="user_input no-margin"
                  name="select_on_block"
                />
              </div>
            </template>
            <template #filter.productName>
              <div class="pa-1">
                <custom-input-text
                  clearable
                  class="user_input no-margin"
                  :placeholder="$t('name')"
                  @input="onChangeHandler"
                  v-model="ourProductFilter.name"
                  type="text"
                />
                <!--                <custom-input-text-->
                <!--                  :get-item-promise="-->
                <!--                    ({ text, page }) =>-->
                <!--                      $store.dispatch('getProducts', {-->
                <!--                        name: text,-->
                <!--                        page,-->
                <!--                        limit: 15,-->
                <!--                      })-->
                <!--                  "-->
                <!--                  @item-resolved="setProduct"-->
                <!--                  @next-page-resolved="-->
                <!--                    (data) => setProduct([...products, ...data])-->
                <!--                  "-->
                <!--                  :items="products"-->
                <!--                  v-model="ourProductFilter.productName"-->
                <!--                  @input="onChangeHandler"-->
                <!--                  clearable-->
                <!--                  infinite-->
                <!--                  class="no-margin"-->
                <!--                  name="select_on_block"-->
                <!--                >-->
                <!--                  <template #option="{ item }">-->
                <!--                    <v-list-item-title>-->
                <!--                      <p class="ma-0">{{ item.name }}</p>-->
                <!--                      <span class="v-messages">{{-->
                <!--                        item.attrs.join(" && ")-->
                <!--                      }}</span>-->
                <!--                    </v-list-item-title>-->
                <!--                  </template>-->
                <!--                </custom-input-text>-->
              </div>
            </template>
            <template #filter.productAttrs>
              <div class="pa-1">
                <custom-input-text
                  v-model="ourProductFilter.productAttributes"
                  @input="onChangeHandler"
                  clearable
                  class="user_input no-margin"
                  name="select_on_block"
                />
              </div>
            </template>
            <template #item.unitTypeName="{ item }"
              >{{ item[`unit_type_name_${$i18n.locale}`] }}
            </template>
            <template #item.productAttrs="{ item }">
              {{ item.productAttrs.join(" || ") }}
            </template>
            <template #item.action="{ item }">
              <!--              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-btn-->
              <!--                    @click="printQr(item)"-->
              <!--                    v-bind="attrs"-->
              <!--                    v-on="on"-->
              <!--                    class="new_style"-->
              <!--                  >-->
              <!--                    <vue-icon icon="newPrintIcon"></vue-icon>-->
              <!--                  </v-btn>-->
              <!--                </template>-->
              <!--                <span>{{ $tc("printQrCode", 1) }}</span>-->
              <!--              </v-tooltip>-->
              <div class="ml-4">
                <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :to="{
                        name: 'product-history',
                        query: {
                          productItemId: item.id,
                          // warehouseId: item['warehouseId'],
                        },
                      }"
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                    >
                      <vue-icon icon="newTimeIcon" />
                    </v-btn>
                  </template>
                  <span>{{ $t("productHistory") }}</span>
                </v-tooltip>
              </div>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          go-to
          max-page
          @update:limit="
            (limit) => {
              configuration.pagination.limit = limit;
              configuration.pagination.page = 1;
              onChangeHandler();
            }
          "
          v-model="configuration.pagination.page"
          :length="lastPage"
          @input="changePage"
          :limit="configuration.pagination.limit"
        />
      </div>
    </div>
    <ProductMoveToOtherDepartment
      @UPDATED="onUpdated"
      :selectedItemsNumber="selectedItems.length"
      ref="productMoveToOtherDepartment"
    ></ProductMoveToOtherDepartment>
  </div>
</template>

<script>
import { debounce, makerPagination, trueSet } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
// import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { QrService } from "@/utils/QrService";
import { LotTemplate } from "@/utils/qr-template/LotTemplate";
import Downloader from "@/components/ui/downloader";
import ProductMoveToOtherDepartment from "@/components/product/ProductMoveToOtherDepartment.vue";
import { ADDITIONAL_ROLES } from "@/utils/constants.js";

export default {
  props: ["id"],
  data() {
    return {
      isShowFilter: false,
      ourProductFilter: {
        orderNumb: null,
        productAttributes: null,
        contractNumb: null,
        name: null,
        accountingCode: null,
      },
      selectedItems: [],
      lastPage: 0,
      configuration: {
        pagination: {
          page: 1,
          limit: "50",
        },
        options: {
          sortBy: "id",
          sortDirection: true,
        },
      },
      items: [],
      contracts: [],
      products: [],
    };
  },
  methods: {
    openMoveProductDialog() {
      const items = [];
      this.selectedItems.forEach((id) => {
        const product = this.items.find((item) => item.id === id);
        if (product) items.push(product);
      });
      this.$refs.productMoveToOtherDepartment.open(items);
    },
    trueSet,
    onUpdated() {
      this.getProductItemsByFilter();
      this.selectedItems = [];
    },
    setProduct(products) {
      this.products = products;
    },
    onChangeHandler: debounce(function () {
      this.getProductItemsByFilter();
    }, 300),
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsByFilter() {
      if (this.ready) {
        this.showLoading();
        const { page } = this.configuration.pagination;
        if (page !== 1) {
          this.configuration.pagination.page = 1;
          await this.$router.push({ query: { page: `1` } });
        }
        await this.getProductItems();
        this.clearLoading();
      }
    },
    async getProductItemsBySort() {
      this.showLoading();
      const { query: initialQuery } = this.$route;
      const query = {
        ...initialQuery,
        ...this.configuration.pagination,
        ...this.configuration.options,
      };
      try {
        await this.$router.push({ query });
      } catch (e) {
        this.setResponseError({ error: e });
      }
      await this.getProductItems();
      this.clearLoading();
    },
    async getProductItems() {
      const { page, limit } = this.configuration.pagination;
      let params = {
        warehouseIds: this.id,
        ...this.configuration.options,
        ...this.ourProductFilter,
        page: page - 1,
        forPrintQrCode: true,
        limit,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("product-item/list", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async printQr(item) {
      const qrService = new QrService();
      const qrTemplate = new LotTemplate();
      await qrTemplate.addQr(`{id: ${item.id}}`);
      qrTemplate.addText(`id: ${item.id}`);
      qrTemplate.addText(`№:${item.contractCode}`);
      qrService.add(qrTemplate.data);
      qrService.show(item.name + "_qr");
    },
  },
  async created() {
    this.showLoading();
    try {
      const { page, sortBy, sortDesc } = this.$route.query;
      if (page) this.configuration.pagination.page = +page;
      if (sortBy) this.configuration.options.sortBy = sortBy;
      if (typeof sortDesc !== "undefined")
        this.configuration.options.sortDesc = trueSet(sortDesc);
      await this.getProductItems();
      if (this.$can(this.$permissions.CONTRACT)) {
        const { data: contracts } = await this.$store.dispatch("getContracts");
        this.contracts = contracts;
      }
      // const { data: products } = await this.$store.dispatch("getProducts");
      // this.products = products;
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("№"),
          value: "number",
          style: "min-width: 50px",
        },
        { text: this.$t("product"), value: "productName" },
        { text: this.$t("stillageAddress"), value: "stillageAddress" },
        { text: this.$t("carriageAddress"), value: "carriageAddress" },
        { text: this.$t("count"), value: "count" },
        { text: this.$t("unit"), value: "unitTypeName" },
        {
          text: this.$t("typeProduct"),
          value: `product_type_name_${this.$i18n.locale}`,
        },
        { text: this.$t("action"), value: "action" },
      ];
    },
    canMoveProduct() {
      return this.$can(this.$permissions["SEE_ALL_PRODUCTS_IN_WAREHOUSE"]);
    },
    canChangeMaterial() {
      return this.$store.getters.additionalRoles.includes(
        ADDITIONAL_ROLES.SEE_ALL_PRODUCTS_IN_WAREHOUSE
      );
    },
  },
  components: {
    VuePagination,
    // VueSelect,
    TableWithFilter,
    BackBtn,
    Downloader,
    ProductMoveToOtherDepartment,
  },
};
</script>
